import React from 'react';
import {grey} from "@mui/material/colors";
import InventoryOutlinedIcon from '@mui/icons-material/InventoryOutlined';
import CreditScoreOutlinedIcon from '@mui/icons-material/CreditScoreOutlined';
import LocalPrintshopOutlinedIcon from '@mui/icons-material/LocalPrintshopOutlined';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import TaskAltOutlinedIcon from '@mui/icons-material/TaskAltOutlined';
const statusIcons = {
    'open': InventoryOutlinedIcon,
    'payment-accepted': CreditScoreOutlinedIcon,
    'in-production': LocalPrintshopOutlinedIcon,
    'shipping': LocalShippingOutlinedIcon,
    'finalized': TaskAltOutlinedIcon
};

function StatusIcon(props) {
    const {completed, active, ownerState} = props;
    const {labelName} = ownerState.slotProps;
    const Icon = statusIcons[labelName];

    const getColor = () => {
        if (completed) {
            return 'primary.main';
        }
        if (active) {
            return 'secondary.main';
        }

        return grey[200];
    }

    return (
        <Icon sx={{color: getColor()}}/>
    );
}

export default StatusIcon;
